// extracted by mini-css-extract-plugin
export var btn = "button_black-module--btn--00deb";
export var icon = "button_black-module--icon--c325a";
export var outline = "button_black-module--outline--fd3f5";
export var primary = "button_black-module--primary--5d801";
export var small = "button_black-module--small--fd2b3";
export var text = "button_black-module--text--ba44a";